import { type TRegionMarker } from '@/entities/map'
import { useOverlay } from '@/shared/lib'

import {
  type RegionOverlay,
  type RegionOverlayProps,
  createRegionOverlay,
} from '.'

import { getContent } from './element'

export const useRegionOverlay = () => {
  const manager = useOverlay<RegionOverlay, RegionOverlayProps, TRegionMarker>({
    createInstance: createRegionOverlay,
    getOverlayOptions: item => ({
      zIndex: 30,
      content: getContent({
        name: item.name,
        type: item.regionType,
      }),
      nextZoomLevel: item.nextZoomLevel,
    }),
  })

  return manager
}
